import * as FileSaver from "file-saver";
import { Workbook, Alignment } from "exceljs";


const Export = (csvData, fileName, totalCols, fileType) => {

    /* exceljs */
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet();
    let fileExtension = ".xlsx";
    let typedWorkbook = workbook.xlsx;

    if (fileType === 'csv') {
        typedWorkbook = workbook.csv;
        fileExtension = ".csv";
    }

    const headers = Object.keys(csvData[0]);
    let headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell, i) => {
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "808080" },
            bgColor: { argb: "" },
        };
        cell.font = {
            color: { argb: "FFFFFF" },
        };
    });
    csvData.forEach((d) => {
        let row = worksheet.addRow(Object.values(d));
		if(fileType !== 'csv'){
			row.eachCell((cell, i) => {
				const cellValue = cell.value.toString();
				if (cellValue && /^\d+(\.\d+)?%$/.test(cellValue)) {
					cell.numFmt = '0%';
                    cell.value = Math.round(cellValue.replace('%','')) / 100;
					cell.alignment = { horizontal: 'left' };
				}
			});
		}
    });
    let totalData = headers.map((h, i) => {
        if (i === 0) {
            return csvData.length + " items";
        }
        //if (h.includes("$"))
        if (totalCols.includes(h)) {
            let total = csvData.reduce((a, b) => {
                return Number(a + Number(Object.values(b)[i])??0);
            }, 0);

			if (isNaN(total))
				return '';

			return total;
        }
        return "";
    });
    let totalRow = worksheet.addRow(totalData);
    totalRow.eachCell((cell, i) => {
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFE0" },
            bgColor: { argb: "" },
        };
    });
    worksheet.columns.forEach(function (column, i) {
        var maxLength = 0;
        column["eachCell"]({ includeEmpty: true }, function (cell) {
            var columnLength = cell.value ? cell.value.toString().length : 10;
            if (columnLength > maxLength) {
                maxLength = columnLength;
            }
        });
        column.width = maxLength < 10 ? 10 : maxLength;
    });
    const options = {
        dateFormat: 'DD/MM/YYYY HH:mm:ss',
        dateUTC: true, // use utc when rendering dates
        formatterOptions: {
            delimiter: ';',
            writeBOM: true
        }
    };

    typedWorkbook.writeBuffer(options).then((data) => {
        let blob = new Blob([data], {
            type: fileType,
        });
        FileSaver.saveAs(blob, fileName + fileExtension);
    });
};

export default Export;
